export class DealsLog {
    constructor({
                    //attributes
                    id= null,
                    title= null,
                    description= null,
                    deal_id=  null,
                    custom_product_id= null,
                    product_id= null,
                    user_id= '',
                    company_id= '',
                    type=null,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    is_removed_from_calc=false,
                    custom_product= null,
                    value=0,
                } = {}) {

        //fill attributes
        this.id=id;
        this.title=title;
        this.description=description;
        this.deal_id=deal_id;
        this.custom_product_id=custom_product_id;
        this.product_id=product_id;
        this.user_id=user_id;
        this.company_id=company_id;
        this.type=type;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;
        this.is_removed_from_calc=is_removed_from_calc;
        this.value=value;

        //relations
        this.custom_product=custom_product;
    }

}

export function createDealsLog(data={}) {
    return Object.freeze(new DealsLog(data));
}